"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("@angular/router");
const job_list_component_1 = require("./job-list.component");
const AppRoutes = [
    { path: '', component: job_list_component_1.JobListComponent, pathMatch: 'full' }
];
class JobsModule {
}
exports.JobsModule = JobsModule;
